export const scsNews = {
    postToggle(){
        const toggle = document.querySelector('.show-more-posts');
        const overflow = document.querySelector('.posts-overflow');

        if(toggle){
            toggle.addEventListener('click', function(e){
                e.preventDefault();

                overflow.classList.remove('d-none');
                toggle.classList.add('d-none');
            });
        }
    }
}